var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12ZM8 8C5.79086 8 4 9.79086 4 12C4 14.2091 5.79086 16 8 16H16C18.2091 16 20 14.2091 20 12C20 9.79086 18.2091 8 16 8H8Z",
    fill: "#0E35AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 13.6569 9.65685 15 8 15C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12Z",
    fill: "#0E35AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile4);
export default __webpack_public_path__ + "static/media/mobile-4.a35c0fa11abacd87a7ef0e0dcdc58e7d.svg";
export { ForwardRef as ReactComponent };